import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";

export default function TechPartnersPathwayNav() {
  return (
    <section className="bg-tie-grey-light py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal>
            <div className="p-6 md:p-8 rounded-2xl bg-white border border-tie-grey-dark">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                <div>
                  <h3 className="text-lg md:text-xl font-semibold text-tie-text-primary">
                    Explore the Innovation Ecosystem
                  </h3>
                  <p className="mt-1 text-sm text-tie-text-secondary">
                    Technology partners power the solutions that PIIC and PTIM deploy across factories.
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <Link
                  to="/piic"
                  className="flex items-center justify-between p-4 rounded-xl bg-tie-grey-light hover:bg-tie-teal/10 transition-colors border border-tie-grey-dark hover:border-tie-teal/20"
                >
                  <div>
                    <span className="text-xs font-bold text-tie-teal uppercase tracking-wider">PIIC</span>
                    <p className="text-sm text-tie-text-secondary mt-0.5">Innovation Circles</p>
                  </div>
                  <i className="ri-arrow-right-line text-tie-teal" />
                </Link>
                <Link
                  to="/ptim"
                  className="flex items-center justify-between p-4 rounded-xl bg-tie-grey-light hover:bg-tie-teal/10 transition-colors border border-tie-grey-dark hover:border-tie-teal/20"
                >
                  <div>
                    <span className="text-xs font-bold text-tie-teal uppercase tracking-wider">PTIM</span>
                    <p className="text-sm text-tie-text-secondary mt-0.5">Test Before Scale</p>
                  </div>
                  <i className="ri-arrow-right-line text-tie-teal" />
                </Link>
                <Link
                  to="/experts"
                  className="flex items-center justify-between p-4 rounded-xl bg-tie-grey-light hover:bg-tie-teal/10 transition-colors border border-tie-grey-dark hover:border-tie-teal/20"
                >
                  <div>
                    <span className="text-xs font-bold text-tie-teal uppercase tracking-wider">Experts</span>
                    <p className="text-sm text-tie-text-secondary mt-0.5">On-Demand Specialists</p>
                  </div>
                  <i className="ri-arrow-right-line text-tie-teal" />
                </Link>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}